"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.channelOptions = exports.validationConfig = exports.initialProductConfigurationValues = exports.baseFields = exports.columns = exports.INITIAL_VISIBLE_COLUMNS = void 0;
exports.INITIAL_VISIBLE_COLUMNS = ["name", "channel", "actions"];
exports.columns = [
    { name: "Name", uid: "name", sortable: true },
    { name: "Channel", uid: "channel", sortable: true },
    { name: "Actions", uid: "actions", sortable: false },
];
exports.baseFields = [
    { key: "add_ons", label: "Add Ons" },
    { key: "availability", label: "Availability" },
    { key: "barcode", label: "Barcode" },
    { key: "brand", label: "Brand" },
    { key: "category_id", label: "Category ID" },
    { key: "channels", label: "Channels" },
    { key: "continue_selling_when_out_of_stock", label: "Continue Selling When Out Of Stock" },
    { key: "cost_price", label: "Cost Price" },
    { key: "depth", label: "Depth" },
    { key: "ean13", label: "EAN13" },
    { key: "height", label: "Height" },
    { key: "manufacturer", label: "Manufacturer" },
    { key: "mpn", label: "MPN" },
    { key: "notes", label: "Notes" },
    { key: "notify_when_stock_low", label: "Notify When Stock Low" },
    { key: "on_promotion", label: "On Promotion" },
    { key: "price", label: "Price" },
    { key: "promotion_price", label: "Promotion Price" },
    { key: "quantity", label: "Quantity" },
    { key: "quantity_type", label: "Quantity Type" },
    { key: "sku", label: "SKU" },
    { key: "tags", label: "Tags" },
    { key: "title", label: "Title" },
    { key: "track_quantity", label: "Track Quantity" },
    { key: "url", label: "URL" },
    { key: "vatable", label: "Vatable" },
    { key: "weight", label: "Weight" },
    { key: "width", label: "Width" },
];
exports.initialProductConfigurationValues = {
    name: "",
    channel: "",
};
exports.validationConfig = {
    name: {
        required: true,
        minLength: 2,
        maxLength: 50,
    },
    channel: {
        required: true,
    },
};
exports.channelOptions = [
    { key: "GOOGLE", label: "Google" },
    { key: "SHOPIFY", label: "Shopify" },
    { key: "FACEBOOK", label: "Facebook" },
    { key: "ARCH_STORE", label: "Arch Store" },
    { key: "SIMPHONY", label: "Simphony" },
    { key: "STS", label: "STS" },
    { key: "SALES_LAYER", label: "Sales Layer" },
    { key: "GOOGLE_MERCHANT_CENTER", label: "Google Merchant Center" },
];
